import { useEffect } from 'react';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { apiClient } from '../../common/ApiClient';
import { setDefaultTimezone } from '../../common/utils/dateUtils';
import { ConfigurationSchema } from '../schema/ConfigurationSchema';

enum ConfigurationUrl {
  CONFIGURATION = '/configuration',
}

const getConfiguration = () =>
  apiClient
    .get(ConfigurationUrl.CONFIGURATION)
    .then((response) => ConfigurationSchema.parse(response.data));

const useConfigurationQueryInternal = createApiQueryHook(
  ['configuration'],
  getConfiguration,
  {
    staleTime: Infinity,
    gcTime: Infinity,
  },
);

export const useConfigurationQuery: typeof useConfigurationQueryInternal = (
  ...args
) => {
  const query = useConfigurationQueryInternal(...args);

  useEffect(() => {
    if (query.data?.timezone) {
      // Set the default timezone for dayjs().tz() and dayjs.tz()
      setDefaultTimezone(query.data.timezone);
    }
  }, [query.data]);

  return query;
};
